import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

class LocalityField extends Component {
    constructor(props) {
        super(props);

        this.state = { isValid: false, validValue: "" };
    }

    onChange = (event, { newValue }) => {
        if (this.state.isValid)
            this.setState({ isValid: false });

        this.props.input.onChange(newValue);
    }

    onFocus = () => {
        this.props.input.onChange("");
    }

    onBlur = () => {
        const { input } = this.props;

        if (!this.state.isValid)
            input.onChange("");
    }

    formatSuggestion = suggestion => `${suggestion.city}, ${suggestion.postcode}, ${suggestion.state}`

    render() {
        const { name, label, placeholder, inputClassName, suggestions, onSuggestionsFetch, onSuggestionsClear, input, meta } = this.props;
        
        return (
            <div className={"form-group" + (meta.touched && meta.error ? " has-error" : "")}>
                <label className="control-label" htmlFor={name}>{label}</label>
                <Autosuggest 
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetch}
                    onSuggestionsClearRequested={onSuggestionsClear}
                    getSuggestionValue={this.formatSuggestion}
                    renderSuggestion={suggestion => <div>{this.formatSuggestion(suggestion)}</div>}
                    inputProps={{ 
                        value: input.value, 
                        onChange: this.onChange.bind(this),
                        onFocus: this.onFocus.bind(this),
                        onBlur: this.onBlur.bind(this),
                        className: inputClassName,
                        placeholder: placeholder
                    }}
                    onSuggestionSelected={(event, { suggestionValue }) => { this.setState({ isValid: true, validValue: suggestionValue }); }}
                />
                {meta.touched && meta.error ? ( 
                    <span className="help-block">{meta.error}</span>
                ) : null}
            </div>
        );
    }
}

export default LocalityField;


// WEBPACK FOOTER //
// ./app/address/components/localityField.js